import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";
import { RunExternalDependency } from "types/generated";
import Box from "ds/components/Box";
import { TreeBranch, TreeBranchLink, TreeItem } from "ds/components/Tree";
import Timestamp from "components/Timestamp";
import { isExternalDependencySkippable } from "shared/Run/useSkipExternalDependency/accessValidation";
import { AccessResult } from "utils/access";
import HistoryEntryWrapperSeparator from "components/Run/elements/HistoryEntryWrapper/Separator";
import SkipExternalDependencyButton from "components/Run/elements/SkipExternalDependecyButton";

import ExternalDependencyBadge from "./ExternalDependencyBadge";

type DependenciesEntryExternalDependencyProps = {
  item: RunExternalDependency;
  canSkipExternalDependencies: AccessResult;
};

const DependenciesEntryExternalDependency = ({
  item,
  canSkipExternalDependencies,
}: DependenciesEntryExternalDependencyProps) => {
  const isSkippable = isExternalDependencySkippable(item);
  return (
    <TreeBranch>
      <TreeBranchLink
        gap="medium"
        padding="small small small 0"
        grid
        gridTemplate="max-content auto max-content"
        align="center"
      >
        <TreeItem autoHeight>
          <Typography variant="p-body3" tag="span" color="secondary">
            External dependency
          </Typography>
          <TextEllipsis tooltip={item.id} delay={400}>
            {(props) => (
              <Typography {...props} tag="span" variant="p-body3">
                {item.id}
              </Typography>
            )}
          </TextEllipsis>
          <Box gap="medium" align="center">
            <ExternalDependencyBadge state={item.status} />
            <HistoryEntryWrapperSeparator margin="0" />
            <Timestamp color="secondary" timestamp={item.completedAt || item.createdAt} />
            {isSkippable && (
              <SkipExternalDependencyButton
                canSkipExternalDependencies={canSkipExternalDependencies}
                dependencyId={item.id}
                runQueryToRefetch="GetRun"
              />
            )}
          </Box>
        </TreeItem>
      </TreeBranchLink>
    </TreeBranch>
  );
};

export default DependenciesEntryExternalDependency;
